(function($){

	OH.settings.xfadeDefine = (function(){
		var define = new Object();

		define.sort = {
			normal : function(original){
				return original;
			},
			shuffle : function(original){
				var num = original.length;
				while(num > 0){
					var index = Math.floor(Math.random() * num--);
					var target = original[num];
					original[num] = original[index];
					original[index] = target;
				}
				return original;
			}
		};

		define.currentTopMargin = function(){
			return $('header.l-header').height();
		};

		define.paginationButton = function(){
			var transformPropName = OH.transitionalStyleProperty("transform", "_");
			var transformOriginPropName = OH.transitionalStyleProperty("transform-origin", "_");
			var nameSpace = "http://www.w3.org/2000/svg";
			var svg = document.createElementNS(nameSpace, "svg");
			svg.setAttribute("xmlns", nameSpace);
			svg.setAttribute("width", 11);
			svg.setAttribute("height", 11);

			svg.setAttribute("viewbox", "0 0 11 11");

			var circle = document.createElementNS(nameSpace, "circle");
			circle.setAttribute("r", 4);
			circle.setAttribute("cx", 6);
			circle.setAttribute("cy", 6);
			circle.setAttribute("stroke", "#333333");
			circle.setAttribute("stroke-width", 1);
			circle.setAttribute("fill", "red");

			svg.appendChild(circle);
			svg.style.width = "11px";
			svg.style.height = "11px";
			//svg.style[transformPropName] = "scale(0.1)";
			//svg.style[transformOriginPropName] = "0px 0px";
			return svg;
		};
		
		define.elementalChangerProps = {
			stylePrefix : "",
			interval : 5000,
			shiftDuration : 500
		};
		
		define.elementalSync = {
			shiftInterval : 5000,
			shiftDuration : 1000,
			appearDuration : 60,
			panelWidth : 100,
			panelWidthUnit : "%",
			areaHeight : 510,
			breakPoint : 1050,
			contentMaxWidth : 880,
			contentMinWidth : 768,
			scalableBreakPoint : 980,
			spBottomMargin : 28,
			topMargin : 110,
			bottomMargin : 90,
			topBasePadding : 51,
			spBaseWidth : 375,
			spBaseHeight : 202// 278 - 58 - 28 + 10
		};
		
		define.controlByHash = function(){
			var onloadTask = function(){
				if($('[data-rendering-name="events"]').length > 0){
					$('#l-mainVisual').css("display", location.hash == "#refer:today" ? "none" : "block");
				}
			};
			onloadTask();
			$(window).on("hashchange", onloadTask);
		};
		

		return define;
	})();
})(jQuery);
